export enum KnmDataViolationPathsTemplateEnum {
  ATR = '/knm/approve/documents/0/atr',
  CHECKLISTS = '/knm/objects/{guid}/checklists/{guid}',
  CREATED = '/knm/created',
  DATE = '/knm/approve/documents/0/date',
  DISTRICT = '/knm/district',
  DURATION_DAYS = '/knm/approve/durationDays',
  DURATION_HOURS = '/knm/approve/durationHours',
  ERPID = '/knm/erpId',
  EVENTS = '/knm/events',
  EVENTS_ITEM = '/knm/events/{guid}',
  FUNCTIONS = '/knm/knoOrganization/functions',
  FUNCTIONS_ITEM = '/knm/knoOrganization/functions/{guid}',
  IMPOSSIBLE_CONDUCTION_REASON = '/knm/approve/impossibleConductionReason',
  INN = '/knm/organization/inn',
  INSPECTION_TARGET = '/knm/approve/inspectionTarget',
  INSPECTORS = '/knm/inspectors',
  INSPECTORS_ITEM = '/knm/inspectors/{guid}',
  KIND = '/knm/kind',
  KNO_ORGANIZATION = '/knm/knoOrganization',
  LAWSUITS = '/knm/objects/{guid}/result/{guid}/violations/{guid}/lawsuits/{guid}',
  LEGAL_BASES = '/knm/legalBases',
  LEGAL_BASES_ITEM = '/knm/legalBases/{guid}',
  NAME = '/knm/organization/name',
  NOTICE_DATE = '/knm/noticeDate',
  NOTICE_METHOD = '/knm/noticeMethod',
  OBJECTS = '/knm/objects',
  OBJECTS_ITEM = '/knm/objects/{guid}',
  OGRN = '/knm/organization/ogrn',
  PLAN_ID = '/knm/planId',
  REQUIREMENTS = '/knm/requirements',
  REQUIREMENTS_ITEM = '/knm/requirements/{guid}',
  RESULT = '/knm/objects/{guid}/result',
  RESULT_ACT_CREATE_DATE = '/knm/objects/{guid}/result/{guid}/actCreateDate',
  RESULT_ADDITIONAL_INFO = '/knm/objects/{guid}/result/{guid}/additionalInfo',
  RESULT_ADDITIONAL_INFO_ITEM = '/knm/objects/{guid}/result/{guid}/additionalInfo/{guid}',
  RESULT_DELEGATES = '/knm/objects/{guid}/result/{guid}/delegates',
  RESULT_DELEGATES_ITEM = '/knm/objects/{guid}/result/{guid}/delegates/{guid}',
  RESULT_DURATION_DAYS = '/knm/objects/{guid}/result/{guid}/durationDays',
  RESULT_DURATION_HOURS = '/knm/objects/{guid}/result/{guid}/durationHours',
  RESULT_INSPECTORS = '/knm/objects/{guid}/result/{guid}/inspectors',
  RESULT_INSPECTORS_ITEM = '/knm/objects/{guid}/result/{guid}/inspectors/{guid}',
  RESULT_START_DATE = '/knm/objects/{guid}/result/{guid}/startDate',
  START_DATE = '/knm/startDate',
  STOP_DATE = '/knm/stopDate',
  SUPERVISION_TYPE = '/knm/supervisionType',
  SUPERVISIONS = '/knm/objects/{guid}/supervisions/{guid}',
  TYPE = '/knm/type',
}
